
  

<div class="grid">

	<div class="col-12">

		<div class="card cardbig">
	
			<p-table #maintable 
                [value]="dataList" 
                [columns]="cols"
                dataKey="id" 
                [rows]="30" 
                [ngClass]="{'hideFilter': hideFilter}"
                [loading]="loading" 
                sortField="name" 
                [rowHover]="true" 
                styleClass="p-datatable-gridlines" 
                [paginator]="true" 
                responsiveLayout="scroll">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-between flex-column sm:flex-row">
                        <button pButton label="{{ lang.el(nuovoLabel)}}" *ngIf="newRecordUrl!=''"
                        class="p-button-outlined mb-2" icon="pi pi-plus" (click)="nuovoRecord()"></button>
                        
                        <div class="flex">
                            <span class="p-input-icon-left mb-3 ml-2"  *ngIf="!noFilter">
                                <p-button (click)="hideFilter=!hideFilter" *ngIf="hideFilter" icon="pi pi-filter-fill mb-2 " 
                                [rounded]="true" [text]="true" />
                                <p-button (click)="hideFilter=!hideFilter" *ngIf="!hideFilter" icon="pi pi-filter-slash mb-2 " 
                                [rounded]="true" [text]="true"  />
                            </span>
                            <span class="p-input-icon-left mb-4 ml-2">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" #filter (input)="onGlobalFilter(maintable, $event)" 
                                placeholder="{{lang.el('Ricerca')}} ..." class="w-full"/>
                            </span>
                        </div>
					</div>
				</ng-template>
				<ng-template  pTemplate="header" let-columns>
                    <tr>
                             <th *ngFor="let col of columns" 
                             [pSortableColumn]="col.field" 
                             [pSortableColumnDisabled]="col.pSortableColumnDisabled" 
                             [style]="col.style">
                                {{ lang.el(col.header) }} <p-sortIcon *ngIf="!col.pSortableColumnDisabled" field="col.field" />
                            </th>
                       
                    </tr>
                    <tr *ngIf="!noFilter">
                        <th *ngFor="let col of columns">
                            <p-columnFilter *ngIf="col.filter && col.type=='field'"
                                type="text"
                                [field]="col.field"
                                [matchModeOptions]="matchModeOptions"
                                [matchMode]="matchMode" />

                            <p-columnFilter *ngIf="col.filter && col.type=='date'" 
                                type="date" [field]="col.field" display="menu">
                                <ng-template pTemplate="filter" let-filter="filterCallback">
                                    <p-calendar dateFormat="dd/mm/yy" (onSelect)="filter($event)"></p-calendar>
                                </ng-template>
                            </p-columnFilter>    
                        </th>
                    </tr>
				</ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns">
                            <div *ngIf="col.type=='edit'" class="flex">
                                <button pButton pRipple icon="pi pi-pencil" 
								class="p-button-rounded p-button-text" (click)="edit(rowData)"></button>
                            </div>
                            <div *ngIf="col.type=='settings'" class="flex">
                                <button pButton pRipple icon="pi pi-wrench" 
								class="p-button-rounded p-button-text" (click)="settings(rowData)"></button>
                            </div>
                            <div *ngIf="col.type=='field'" [style]="col.style">
                                {{ rowData[col.field] }}
                            </div>
                            <div *ngIf="col.type=='currency'" [style]="col.style">
                                {{rowData[col.field] |currency:'EUR':'symbol' }}
                            </div>
                            
                            <div *ngIf="col.type=='date'" [style]="col.style">
                                {{ rowData[col.field] | date: 'dd/MM/yyyy' }}
                            </div>
                            
                            <div *ngIf="col.type=='check'" class="text-center">
                                <i class="pi" [ngClass]="{'true-icon pi-check-circle text-green-500': rowData[col.field], 'false-icon pi-times-circle text-pink-500': !rowData[col.field]}"></i>
                            </div>
                            <div *ngIf="col.type=='delete'" class="flex">
                                <button pButton pRipple icon="pi pi-trash" 
								class="p-button-rounded p-button-text" (click)="delete(rowData)"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
				
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="8">{{lang.el('Nessun record presente')}}</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="8">{{lang.el('Caricamento in corso')}} ...</td>
					</tr>
				</ng-template>
    		</p-table>
		</div>

	</div>

       
    <p-toast />

    <p-confirmDialog  [acceptButtonStyleClass]="'p-button-text'"
    [rejectButtonStyleClass]="'p-button-text p-button-danger'"></p-confirmDialog>